import React, {useState} from 'react'
import {connect} from "react-redux";

import TSlider from "./slider";
import Dirbutton from "./dirbutton";
import {send_lc_cmd} from "../etc/cmd";
import SliderNt from "./slider_nt";

const DriveBox = ({lc, gs, width}) => {

    const [v, setV] = useState(lc.v);
    const [dir, setDir] = useState(lc.dir);
    const [fn, setFn] = useState(lc.fn);

    function vChanged(val) {

        if( v !== val) {
            setV(val)
        } else {
            return
        }

        let lcdir = lc.dir
        if (lcdir === "1" || lcdir === "true" || lcdir > 0) {
            lcdir = true
        } else if (lcdir === "0" || lcdir === "false" || lcdir <= 0) {
            lcdir = false
        }

        let cc = {
            id: lc.id,
            v: parseInt(val),
            dir: lcdir,
            fn: lc.fn,
            mask: 0b00000001
        }
        send_lc_cmd(cc);
    }

    function dirChanged(val) {
        let cc = {
            id: lc.id,
            v: lc.v,
            dir: val,
            fn: lc.fn,
            mask: 0b00000001
        }
        send_lc_cmd(cc);
    }


    let kmh_raw = parseInt(lc.v) > 0 ? lc.bmspeed : 0
    let kmh = (kmh_raw)

    return (
        <div>
            <Dirbutton lc={lc} sendDir={dirChanged} width={width}/>
            <SliderNt lc={lc} sendV={vChanged} width={width}/>
        </div>
    )


    // [{kmh_raw}] {kmh} km/h
}

/*
<TSlider big={big} lc={lc} sendV={this.vChanged}/>
 <div style={{
                margin: '5px',
                padding: '0px',
            }}>{kmh} km/h | {lc.v}</div>
<LinearProgress variant="determinate"

                                sx={{
                                    m: '5px',
                                    width: 'auto',
                                    height: '30px',
                                    backgroundColor: 'var(--inner-background)',
                                    //background: 'rgba(179,199,188,0.75)',
                                    borderRadius: 'var(--border-radius)',
                                    border: 'var(--border)',
                                    colorPrimary: '#334466',
                                }}
                                value={kmh/64*100}
                />
 */

const mapStateToProps = state => {
    return state;
}

const mapDispatchToProps = (dispatch) => ({
    //sendFn: (lc, fn, bit) => dispatch(sendToServer({...lc})),
});

export default connect(mapStateToProps, mapDispatchToProps)(DriveBox)
